import { internalApi } from '$$store/api';

const innerObject = {
  settings: {
    numberFormat: user.settings.numberFormat || GT.user.userSettings?.numberFormat || 'comma-period',
  },
  // Single source of truth is the server's NUMBER_FORMATS (app/protected/extensions/constants.js),
  // injected into GT.numberFormatsData - see the same pattern used for GT.currency.
  numberFormats: GT.numberFormatsData.map(({ ID, VALUE }) => ({ id: ID, value: VALUE })),
  getFormatted: (
    number,
    formatType = innerObject.getUserNumberFormat()?.id,
    options = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  ) => {
    let result;

    switch (formatType) {
      case 'period-comma':
        result = number.toLocaleString('de-DE', options);
        break;
      case 'comma-period':
        result = number.toLocaleString('en-US', options);
        break;
      case 'space-comma':
        result = number.toLocaleString('fr-FR', options);
        break;
      case 'space-period':
        // en-US already has the right decimal separator (".") - Intl has no locale/option that
        // renders group separators as a space directly, so swap en-US's "," group separator for one.
        result = number.toLocaleString('en-US', options).replace(/,/g, ' ');
        break;
      case 'plain-comma':
        result = number.toLocaleString('de-DE', { ...options, useGrouping: false });
        break;
      case 'plain-period':
        result = number.toLocaleString('en-US', { ...options, useGrouping: false });
        break;
      default:
        result = number.toLocaleString(undefined, options);
    }

    return result;
  },
  setUserNumberFormat: async format => {
    innerObject.settings.numberFormat = format;
    await internalApi.put(`/users/${GT.user.id}`, {
      settings: {
        numberFormat: format,
      },
    });
  },
  getUserNumberFormat: () => innerObject.numberFormats.find(item => item.id === innerObject.settings.numberFormat),
};

export default innerObject;
